import React, { useState, Fragment, useEffect } from "react";
import { Table, Image, Col, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { withRouter, useHistory } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Button } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import { admin_promo_videos_get } from "../../../../store/actions/SuperAdminActions/superAdminPromoVideosAction";
import { admin_delete_role } from "../../../../store/actions/SuperAdminActions/superAdminPromoVideosAction";
import Switch from "react-switch";
import moment from "moment";
import { admin_video_patch } from "../../../../store/actions/SuperAdminActions/superAdminPromoVideosAction";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import Alert from "react-s-alert";

// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations

const SuperAdminPromotionalVideos = (props) => {
  const history = useHistory();
  useEffect(() => {
    // props.admin_video_patch(token);
    getData();
  }, []);
  const getData = () => {
    const token = props.auth.user.accessToken;
    props.admin_promo_videos_get(token);
  };

  const videoTypes = [
    { id: 0, title: "All" },
    { id: 1, title: "Merchant" },
    { id: 2, title: "Admin" },
  ];

  const [videoType, setvideoType] = useState("All");

  const [state, setState] = useState({
    search: "",
    restaurant_type: "",
    request_type: "All",
    showSearch: false,
  });

  const [showFilter, setShowFilter] = useState(false);

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };
  const searchClick = () => {
    setShowFilter(!showFilter);
  };
  const cancelClick = () => {
    setShowFilter(!showFilter);
  };

  const [promoVideos, setPromoVideos] = useState([]);
  useEffect(() => {
    setPromoVideos(props?.promoVideos || []);
  }, [props.promoVideos]);

  let filteredData = [];
  const videoDataArr = promoVideos && promoVideos;
  filteredData = videoDataArr;

  const RenderTableBody = () => {
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filteredData = videoDataArr.filter((getall) => {
        if (search.test(getall?.title)) {
          return getall;
        } else {
          return false;
        }
      });
    }

    if (videoType) {
      filteredData = filteredData.filter((item) => {
        if (videoType === "Merchant") {
          return item?.video_classification === "1";
        } else if (videoType === "Admin") {
          return item?.video_classification === "0";
        } else {
          return item;
        }
      });
    }

    return (
      <React.Fragment>
        {filteredData.map((data, index) => (
          <TableBody
            key={index}
            data={data}
            auth={props.auth}
            admin_video_patch={props.admin_video_patch}
            admin_promo_videos_get={getData}
            admin_delete_role={props.admin_delete_role}
          />
        ))}
      </React.Fragment>
    );
  };

  const downloadData = {
    headers: [
      { label: "Video Title \n ID", key: "video_title" },
      { label: "Start-end Date", key: "date" },
      { label: "video Classification", key: "classification" },
      { label: "Merchant Name or ID\n Event ID", key: "nameId" },
      { label: "Priority", key: "priority" },
      { label: "Tracker", key: "tracker" },
      { label: "Status", key: "status" },
      { label: "Primary", key: "primary" },
    ],
    data: filteredData
      ? filteredData?.map((ele) => {
          return {
            video_title: `${ele?.title || " "} \n ${ele?._id || " "}`,
            date: `${moment(props?.ele?.start_date).format(
              "Do MMM YYYY"
            )} - ${moment(props?.ele?.start_date).format(
              "hh:mm A"
            )} \n ${moment(props?.ele?.end_date).format(
              "Do MMM YYYY"
            )} -   ${moment(props?.ele?.end_date).format("hh:mm A")}`,
            classification:
              ele?.video_classification === "0"
                ? "Admin Promotional Videos"
                : "Merchant Promotional Videos",
            nameId:
              ele?.video_classification === "0"
                ? "-"
                : ele?.merchant_name
                ? ele?.merchant_name
                : ele?.merchant_id
                ? `#${ele?.merchant_id}`
                : "",
            priority: ele?.priority || " ",
            tracker: ele?.tracker === true ? "on" : "off" || " ",
            status: ele?.status || " ",
            primary: ele?.make_video_primary ? "primary" : " ",
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Super Admin Videos
                  <br />
                  <p className="f10-400">
                    View the list of videos created by Super Admin
                  </p>
                </div>
                <div className="col-6 text-right">
                  <button
                    type="button"
                    class="mr-4 px-5 py-2 btn addBtnRed f12-700"
                    style={{ color: "#EE3A23" }}
                    // onClick={this.onOpenModal}
                    onClick={() =>
                      history.push("/superadmin/promotional-videos/add")
                    }
                  >
                    Add Video
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex">
                  <Image
                    onClick={() =>
                      setState({
                        ...state,
                        showSearch: !state.showSearch,
                      })
                    }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    onClick={handleShowFilter}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    // onClick={props.handleClick}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div className="f10-400" align="center">
                    <CSVDownloader
                      filename={"Super Admin videos"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                    <br />
                  </div>
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    {/* <SelectFilter onDateChange={onDateChangeHandler} /> */}
                  </div>
                </div>
                <div className="col-2"></div>
              </div>
              {state.showSearch && (
                <div className="mb-3">
                  <ZoomDiv>
                    <>
                      <br />
                      <Form.Control
                        type="text"
                        placeholder="Search by business name, diner name"
                        name="search"
                        onChange={onSearchChange}
                        value={state.search}
                        className="amSearch"
                      />
                    </>
                  </ZoomDiv>
                </div>
              )}
              {showFilter && (
                <div className="col-12  mt-3">
                  <div className="enWhiteBox mt-3">
                    <Form className="row justify-content-between">
                      <Col md={5}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Offer">
                              video classification
                            </InputLabel>
                            <Select
                              value={videoType}
                              onChange={(e) => setvideoType(e.target.value)}
                              label="Offer"
                              inputProps={{
                                name: "Offer",
                                id: "outlined-Location",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {videoTypes.map((data) => {
                                return (
                                  <option value={data.title} key={data.id}>
                                    {data.title}
                                  </option>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                      <Col>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="outline-secondary"
                            className="btn-lg mr-4 px-5"
                            onClick={cancelClick}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="danger"
                            className="btn-lg px-5"
                            onClick={searchClick}
                          >
                            Search
                          </Button>
                        </div>
                      </Col>
                    </Form>
                  </div>
                </div>
              )}

              <hr />
              <div>
                <div
                  className="d-flex  mt-3 mb-3"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="mr-3 d-flex">
                    <SelectFilter onDateChange={() => {}} />
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Admin Promotional Video",
                        //  loader: props.auth.secondary_loader,
                        value:
                          promoVideos?.filter((item) =>
                            item.video_classification === 1
                              ? item.is_read
                              : null
                          ).length || 0,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Merchant Promotional Video",
                        //  loader: props.auth.secondary_loader,
                        value:
                          promoVideos?.filter((item) =>
                            item.video_classification === 0
                              ? item.is_read
                              : null
                          ).length || 0,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>

              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        Video Title/ <br />
                        ID
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Start <br />
                        Date-Time
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        End <br />
                        Date-Time
                      </td>
                      <td style={{ width: "13%" }} className="f12-400">
                        Video <br />
                        Classification
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Merchant <br />
                        Name or ID/
                        <br />
                        Event ID
                      </td>
                      <td style={{ width: "7%" }} className="f12-400">
                        Priority
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Tracker
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Status
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Primary
                      </td>
                    </tr>
                  </thead>
                  {RenderTableBody()}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const TableBody = (props) => {
  // const [changedvalue, setchangedvalue] = useState({
  //   tracker: false,
  // });
  const token = props.auth.user.accessToken;
  const makePrimary = (data) => {
    props.admin_video_patch(token, props?.data?._id, data, () => {
      props.admin_promo_videos_get(token);
    });
  };

  const [showDeletevideo, seShowDeletevideo] = useState(false);

  const handleCloseDeletevideo = () => {
    seShowDeletevideo(false);
  };

  const deletevideo = () => {
    const token = props.auth.user.accessToken;
    props.admin_delete_role(token, props.data?._id);
  };
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);

  const history = useHistory();

  return (
    <Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css text-break">
                <tr onClick={showTr}>
                  <td style={{ width: "15%" }}>
                    <div className="text-break">
                      <h5 className="font_16_m mt-3">
                        {props?.data?.title || ""}
                      </h5>
                      <p className="f10-400 mt-3">#{props?.data?._id}</p>
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-500">
                      {moment(props?.data?.start_date).format("Do MMM YYYY")}
                      {moment(props?.data?.start_date).format("hh:mm A")}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-500">
                      {moment(props?.data?.end_date).format("Do MMM YYYY")}
                      {moment(props?.data?.end_date).format("hh:mm A")}
                    </div>
                  </td>
                  <td style={{ width: "13%" }}>
                    <div className="f12-500">
                      {props?.data?.video_classification === "0"
                        ? "Admin Promotional Videos"
                        : "Merchant Promotional Videos"}
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-500">
                      {props?.data?.video_classification === "0"
                        ? "-"
                        : props?.data?.merchant_name
                        ? props?.data?.merchant_name
                        : props?.data?.merchant_id
                        ? `#${props?.data?.merchant_id}`
                        : ""}
                    </div>
                    {/* <div className="f12-500">
                    {props?.data?.video_classification === "1"
                      ? ""
                      : `#${props?.data?.merchant_id}` || ""}
                  </div> */}
                    <div className="f12-500 text-primary">
                      {props?.data?.video_classification === "0"
                        ? ""
                        : props?.data?.event_id
                        ? `#${props?.data?.event_id}`
                        : ""}
                    </div>
                  </td>
                  <td style={{ width: "7%" }}>
                    <div className="f12-500">
                      {props?.data?.priority || "-"}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="">
                      <Switch
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                        onChange={() => {
                          makePrimary({ tracker: !props?.data?.tracker });
                        }}
                        checked={props?.data?.tracker || false}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={15}
                        width={41}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="">
                      <Switch
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                        onChange={() => {
                          makePrimary({
                            status:
                              props?.data?.status === "ACTIVE"
                                ? "INACTIVE"
                                : "ACTIVE",
                          });
                        }}
                        checked={
                          props?.data?.status === "ACTIVE" ? true : false
                        }
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={15}
                        width={41}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="">
                      <Switch
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                        onChange={() => {
                          makePrimary({
                            make_video_primary:
                              !props?.data?.make_video_primary,
                          });
                        }}
                        checked={props?.data?.make_video_primary}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={15}
                        width={41}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </td>
                </tr>
                {TrDetail && (
                  <>
                    <tr className="sd_accordion_body">
                      <td style={{ width: "25%" }}>
                        <div className="f12-400">More Details</div>
                        <div className="f12-400 d-flex">
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() => seShowDeletevideo(true)}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/Delete.svg")}
                              alt="Delete"
                              title="Delete"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            // onClick={
                            //   props?.event?.isOnline
                            //     ? () => props.handleShowView(props.event)
                            //     : () => props.handleShowView2(props.event)
                            // }
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            // onClick={props.editDataAction}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="f12-400">Video Tags</div>
                        <div className="f12-400 mt-2">
                          {props?.data?.video_tag.map(
                            (data, index) =>
                              `${data}${
                                index + 1 !== props?.data?.video_tag?.length
                                  ? ", "
                                  : ""
                              }`
                          )}
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      <React.Fragment>
        <Modal show={showDeletevideo} onHide={handleCloseDeletevideo} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to Delete the video ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseDeletevideo}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={deletevideo}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </Fragment>
  );
};
SuperAdminPromotionalVideos.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  promoVideos: state?.promoVideo?.promoVideos,
});

export default connect(mapStateToProps, {
  admin_promo_videos_get,
  admin_video_patch,
  admin_delete_role,
})(withRouter(SuperAdminPromotionalVideos));
